import { forwardRef, type InputHTMLAttributes } from 'react';

import { FIELD_INPUT } from '@/shared/ui-class';
import { cn } from '@/shared/cn';

/**
 * Shared text input for settings forms (connectors, skills, etc.). Captures
 * the long Tailwind class string that was repeated across six call sites in
 * `ConnectorEditor` plus near-twins in `SkillEditor`. Surface comes from
 * the shared `FIELD_INPUT` vocabulary (mode-resolved `bg-input` fill +
 * divider border + `input-focus` focus border).
 */
export type InputFieldProps = InputHTMLAttributes<HTMLInputElement>;

export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  function InputField({ className, ...rest }, ref) {
    return (
      <input
        ref={ref}
        className={cn('w-full', FIELD_INPUT, className)}
        {...rest}
      />
    );
  },
);
